export var toGQLLocale = function (locale) {
    return locale.slice(0, 5);
};
